
import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AddLeadLinkProps {
  className?: string;
}

const AddLeadLink = ({ className = "" }: AddLeadLinkProps) => {
  return (
    <Button
      variant="default"
      size="sm"
      className={cn("items-center gap-1 sm:gap-2 relative overflow-hidden group text-xs sm:text-sm h-8 sm:h-9", className)}
      asChild>

      <Link to="/places">
        <Plus className="h-4 w-4 group-hover:rotate-90 transition-transform duration-200" />
        <span className="hidden xs:inline sm:inline">Find Leads</span>
        {/* Shine effect on hover */}
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500" />
      </Link>
    </Button>);

};

export default AddLeadLink;